import {
  OfferingType,
  ParticipationRecordStatus,
  ParticipationSetStatus,
} from '../../../graphql/__generated__';

// Map Participation Set Review Statuses to Labels (ideally we get these from server instead)
export const participationSetReviewStatusLabels: { [key in ParticipationSetStatus]: string } = {
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
};

export const participationSetReviewStatusChipColors: { [key in ParticipationSetStatus]: string } = {
  IN_PROGRESS: 'primary',
  COMPLETED: 'success',
};

// Whitelisted offering types for sell-side participation management
// Use this wherever we need to filter out offering types that are not supported
export const sellSideParticipationSupportedOfferingTypes = [
  OfferingType.Ipo,
  OfferingType.MarketedFo,
  OfferingType.OvernightFo,
  OfferingType.RegisteredBlock,
  OfferingType.UnregisteredBlock,
  OfferingType.UnderwrittenRd,
];

export const participationRecordLinkStatusLabels: { [key in ParticipationRecordStatus]: string } = {
  PENDING_REVIEW: 'Pending Review',
  REVIEWED: 'Reviewed',
};

export const participationRecordLinkStatusColors: { [key in ParticipationRecordStatus]: string } = {
  PENDING_REVIEW: 'primary',
  REVIEWED: 'success',
};
